export class TimeoutError extends Error {
  timeoutMillis;
  constructor(message, ms = 0) {
    super(message);
    Object.setPrototypeOf(this, TimeoutError.prototype);

    this.timeoutMillis = ms;
  }
}

const promiseTimeout = (promise, timeoutMillis = 5000) => {
  var timeout;

  return Promise.race([
    promise,
    new Promise(function(resolve, reject) {
      timeout = setTimeout(function() {
        reject(new TimeoutError("Timed out in " + timeoutMillis + "ms.", timeoutMillis));
      }, timeoutMillis);
    })
  ]).then(
    v => {
      clearTimeout(timeout);
      return v;
    },
    err => {
      clearTimeout(timeout);
      throw err;
    }
  );
};

export default promiseTimeout;
